function formatStringForURL(str) {
  if (!str) return '';

  // Replace special characters with hyphens and remove multiple consecutive hyphens
  const sanitizedStr = str
    .replace(/[^\w\s-]/g, '') // Replace non-alphanumeric characters with ''
    .replace(/[\s-]+/g, '-') // Replace spaces and hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove hyphens from the beginning and end

  return sanitizedStr.toLowerCase();
}

function generateBlogUrl(blogFrontmatter, variant) {
  const variantRoute = variant ? `/${variant}` : "";
  return encodeURI(
    `${variantRoute}/blogs/` +
      encodeURIComponent(
        replaceAll(replaceAll(blogFrontmatter.title, ",", "-"), " ", "-")
      )
  );
}

function generateBlogCategoryUrl(categorId, isCategory) {
  const labelName = isCategory ? "category" : "tag";
  return `/blogs/${labelName}/${categorId
    .split(" ")
    .join("-")}`.toLocaleLowerCase();
}

module.exports = {
  generateBlogUrl, formatStringForURL,
};

const blockedChars = ["%", ":", "@", "?", "^", "&", "#", "--", "[", "]"];
function replaceAll(str, replaceKey, replaceWith) {
  const s = str
    .replace(/ *\([^)]*\) */g, "")
    .split(replaceKey)
    .map((e) => e.trim())
    .filter((e) => e)
    .filter((e) => e !== replaceWith)
    .map((e) => {
      return blockedChars.reduce((newStr, key) => {
        return newStr.trim().split(key).join("");
      }, e);
    })
    .filter((e) => e)
    .join(replaceWith)
    .toLocaleLowerCase();

  return s;
}
